import { CommonModule } from "@angular/common";
import { EnvironmentProviders, inject, InjectionToken, ModuleWithProviders, NgModule, provideAppInitializer, Provider } from "@angular/core";
import { AAuthCodeFlowService, ACertificateHttpService, ADynamics365ConnectionHttpService, AEntraIdConnectionHttpService, ASharePointConnectionHttpService } from "@coso/connection-forms";
import { DEPLOY_URL, getDeployUrl, IS_SAAS, PRODUCT_LOGO_SVG_PATH, PRODUCT_NAME } from "@coso/utility";
import { WizardModule } from "@coso/wizard";
import { LogsModule } from "./configuration/logs/logs.module";
import { PageHeaderModule } from "./page-header/page-header.module";
import { AuthCodeFlowService } from "./services/auth-code-flow.service";
import { CertificateHttpService } from "./services/certificate.http.service";
import { Dynamics365ConnectionHttpService } from "./services/dynamics-365-connection.http.service";
import { SharePointConnectionHttpService } from "./services/sharepoint-connection.http.service";
import { EntraIdConnectionHttpService } from "./services/entra-id-connection.http.service";
import { VersionService } from "./services";
import { catchError, of, tap } from "rxjs";

export const IS_DOCKER = new InjectionToken<boolean>("isDocker");
let isDockerValue = false;

@NgModule({
  imports: [CommonModule, WizardModule],
  declarations: [],
  providers: [],
  exports: [PageHeaderModule, LogsModule]
})
export class CoreModule {
  static forRoot(isSaaS: boolean): ModuleWithProviders<CoreModule> {
    const providers : EnvironmentProviders | Provider = [
        {
          provide: IS_SAAS,
          useValue: isSaaS
        },
        {
          provide: IS_DOCKER,
          useFactory: () => isDockerValue
        },
        {
          provide: PRODUCT_NAME,
          useValue: "CB Dynamics 365 to SharePoint Permissions Replicator"
        },
        {
          provide: PRODUCT_LOGO_SVG_PATH,
          useValue: "/assets/Dynamics365_100px.png"
        },
        {
          provide: DEPLOY_URL,
          useFactory: getDeployUrl
        },
        {
          provide: ACertificateHttpService,
          useClass: CertificateHttpService
        },
        {
          provide: ADynamics365ConnectionHttpService,
          useClass: Dynamics365ConnectionHttpService
        },
        {
          provide: AEntraIdConnectionHttpService,
          useClass: EntraIdConnectionHttpService
        },
        {
          provide: ASharePointConnectionHttpService,
          useClass: SharePointConnectionHttpService
        },
        {
          provide: AAuthCodeFlowService,
          useClass: AuthCodeFlowService
        }
      ]
      if(!isSaaS){
        providers.unshift(provideAppInitializer(() => {
            const versionService = inject(VersionService);
            return versionService.getIsDocker()
            .pipe(
              tap(isDocker => {
                isDockerValue = isDocker as boolean;
              }),
              catchError(error => {
                if(error && error instanceof Error){
                  console.error("Failed to detect environment type: ", error.message);
                }
                isDockerValue = false;
                return of(false);
              })
            );
          })
        );
      }
    return {
      ngModule: CoreModule,
      providers
    };
  }
}
